import React, { useRef } from "react";
import { useGLTF, Outlines } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials} = useGLTF("/plots/08-Houses.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }
  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube028.geometry}
        material={materials["11-LHouseRoof"]}
        position={[-0.544, 0.819, 0.23]}
        rotation={[0, Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube242.geometry}
        material={materials["11-HouseSill"]}
        position={[-0.544, 0.526, 0.23]}
        rotation={[0, Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube256.geometry}
        material={materials["07-WindowMat"]}
        position={[-0.281, 0.327, 0.446]}
        rotation={[0, Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube291.geometry}
        material={materials["11-SidewalkConcrete"]}
        position={[-0.089, 0.101, 0.078]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube295.geometry}
        material={materials["00-Grass1"]}
        position={[-0.584, 0.102, 0.79]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube323.geometry}
        material={materials["01-TreeTrunk"]}
        position={[0.78, 0.127, -0.638]}
        rotation={[0, 0.163, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube550.geometry}
        material={materials["00-Base3"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube551.geometry}
        material={materials["11-RHouseBase"]}
        position={[0.241, 0.43, -0.553]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube552.geometry}
        material={materials["11-RHouseRoof"]}
        position={[0.241, 0.119, -0.553]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube636.geometry}
        material={materials["11-RHouseShingles"]}
        position={[0.31, 0.795, -0.337]}
        rotation={[0, 0, -0.589]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube654.geometry}
        material={materials["11-LHouseBase"]}
        position={[-0.544, 0.43, 0.23]}
        rotation={[0, Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube659.geometry}
        material={materials["11-LHouseShingles"]}
        position={[-0.327, 0.795, 0.161]}
        rotation={[-0.589, Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube671.geometry}
        material={materials["02-BenchWood"]}
        position={[-0.268, 0.276, 0.23]}
        rotation={[0, Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Icosphere056.geometry}
        material={materials["01-TreeGreen2"]}
        position={[0.803, 0.436, -0.617]}
        rotation={[-0.159, 0.182, 0.754]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Icosphere057.geometry}
        material={materials["01-TreeGreen1"]}
        position={[-0.55, 0.536, 0.973]}
        rotation={[-Math.PI, 1.037, -Math.PI]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/08-Houses.glb");